<template>
    <b-form @submit.prevent="getMoneyPlacementsData(formData)">
        <b-form-group :label="$t('general.iin')">
            <b-form-input v-model="formData.dealerIin" :disabled="!!Object.keys(taxpayerInfo).length"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('moneyPlacement.txnClientDate')">
            <b-form-select v-model="dateRangeType" :options="dateRangeTypes" v-on:change="dateRangeTypeSelected"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('general.fromDate')">
            <date-picker v-model="formData.txnClientStartDate" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('general.toDate')">
            <date-picker v-model="formData.txnClientEndDateForm" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('kkm.label')">
            <b-form-select :options="kkmOptions" v-model="formData.ccmId">
                <template slot="first">
                    <option :value="null">{{ $t('general.select') }}</option>
                </template>
            </b-form-select>
        </b-form-group>
        <b-form-group :label="$t('moneyPlacement.shiftNumber')">
            <b-form-input v-model="formData.shiftNumber"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('moneyPlacement.amount')">
            <b-form-input v-model="formData.amount"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('moneyPlacement.debet')">
            <b-form-radio-group v-model="formData.debet">
                <b-form-radio :value="true">{{ $t('moneyPlacement.collection') }}</b-form-radio>
                <b-form-radio :value="false">{{ $t('moneyPlacement.replenishment') }}</b-form-radio>
            </b-form-radio-group>
        </b-form-group>
        <b-form-row class="mx-0">
            <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata'
import * as U from '@/utils/utils';

export default {
    name: 'MoneyPlacementSearchForm',
    mixins: [ AppData ],
    props: {
        fetch: Function,
        offset: Number,
        taxpayerInfo: Object,
        pageSize: Number,
        setOffset: Function
    },
    data () {
        return {
            dateRangeType: U.DateRangeType.LastDay,
            kkmList: [],
            formData: {
                dealerId: this.taxpayerInfo.id,
                dealerIin: this.taxpayerInfo.iin,
                ccmId: null,
                shiftNumber: null,
                amount: null,
                debet: null,
                txnClientStartDate: null,
                txnClientEndDateForm: null,
                txnClientEndDate: U.getEndOfCurrentDay(),
                offset: this.offset,
                pageSize: this.pageSize
            },
            datePickerLocale: this.$store.getters.locale.toLowerCase()
        }
    },
    mounted() {
        this.dateRangeTypeSelected();
    },
    computed: {
        kkmOptions: function () {
            return this.$miscUtil.generateSelectList(this.kkmList, 'id', 'factoryNumber')
        },
        dateRangeTypes() {
            return [
                { value: U.DateRangeType.LastHour, text: this.$t('general.lastHour') },
                { value: U.DateRangeType.Last12Hours, text: this.$t('general.last12Hours') },
                { value: U.DateRangeType.LastDay, text: this.$t('general.lastDay') }
            ]
        }
    },
    methods: {
        getMoneyPlacementsData: function (formData) {
            if (this.offset !== 0) {
                this.setOffset(0)
            } else {
                this.fetch(formData)
            }
        },
        fetchKkmList: function () {
            const onSuccess = response => {
                this.kkmList = [];

                if (!Array.isArray(response))
                    throw new Error('Server response must be array');

                for(let ccm of response){
                    if (ccm.creationDate != null)
                        ccm.creationDate = new Date(ccm.creationDate);

                    if (ccm.openingDate != null)
                        ccm.openingDate = new Date(ccm.openingDate);
                    
                    if (ccm.closingDate != null)
                        ccm.closingDate = new Date(ccm.closingDate);
                    
                    if (ccm.blockingDate != null)
                        ccm.blockingDate = new Date(ccm.blockingDate);

                    if (ccm.ofdBlockingDate != null)
                        ccm.ofdBlockingDate = new Date(ccm.ofdBlockingDate);
                    
                    ccm._showDetails = false;

                    this.kkmList.push(ccm);
                }
            };

            this.$request.sendRequest(
                this,
                this.$appConfig.apiUrls.kkm.getAll,
                { dealerId: this.taxpayerInfo.id }, 
                onSuccess,
                this.displayAlert);
        },
        dateRangeTypeSelected() {
            const dateRange = U.getDateRange(this.dateRangeType);

            this.formData.txnClientStartDate = dateRange.start;
            this.formData.txnClientEndDateForm = dateRange.end;
        }
    },
    watch: {
        offset: function (newValue) {
            this.formData.offset = newValue
            this.fetch(this.formData)
        },
        taxpayerInfo: function (newTaxpayerInfo) {
            this.formData.dealerIin = newTaxpayerInfo.iin
            this.formData.dealerId = newTaxpayerInfo.id
            this.fetchKkmList()
        }
    }
}
</script>
